import script from "./ReCaptcha.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReCaptcha.vue?vue&type=script&lang=ts&setup=true"

import "./ReCaptcha.vue?vue&type=style&index=0&id=80da6d60&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80da6d60"]])

export default __exports__